import SidePanelInfo from "../components/SidePanelInfo";
import ActionBar from "../actions/ActionBar";
import EditAction from "../actions/EditAction";
import BlockUserAction from "../actions/BlockUserAction";

export default function SidePanelGlobalUsers({ data, onViewPage }: any) {
    return (
        <>
            {data &&
                <>
                    <div className="display--flex gap--s">
                        <h2>{data.name}</h2>
                    </div>
                    <ActionBar>
                        {data.canEdit && <EditAction id={data.id} entityName={data.entityName} />}
                        {data.canEdit && <BlockUserAction data={data} />}
                    </ActionBar>
                    <SidePanelInfo
                        values={[
                            { label: "Email", value: data.email },
                            { label: "Telephone number", value: data.phoneNumber }
                        ]}
                    />
                </>
            }
        </>
    );
}
